// Test IDs for the Insights feature.
export const INSIGHTS = {
    root: 'insights-root',
    headerLink: 'app-header-insights-link',

    // Heatmap (lives on /sessions and /insights)
    heatmap: 'insights-heatmap',
    heatmapDay: 'insights-heatmap-day', // -{YYYY-MM-DD}
    heatmapEmpty: 'insights-heatmap-empty',

    // Per-exercise progression chart
    progressionSection: 'insights-progression-section',
    exercisePicker: 'insights-exercise-picker',
    progressionChart: 'insights-progression-chart',
    progressionEmpty: 'insights-progression-empty',
    seriesToggleWeight: 'insights-series-weight',
    seriesToggleE1rm: 'insights-series-e1rm',
    seriesToggleVolume: 'insights-series-volume',
    rangeToggle: 'insights-range-toggle', // -{30|90|180|365}

    // Muscle-group weekly volume
    muscleVolumeSection: 'insights-muscle-volume-section',
    muscleVolumeChart: 'insights-muscle-volume-chart',
    muscleVolumeEmpty: 'insights-muscle-volume-empty',
};
